import { CustomerCollectionAlertStatus } from 'TypeGen/AccountsReceivable/Collections/customer-collection-alert-status';

export const alertStatusOptions = [
  { ID: CustomerCollectionAlertStatus.Low, Name: 'Low' },
  { ID: CustomerCollectionAlertStatus.Moderate, Name: 'Moderate' },
  { ID: CustomerCollectionAlertStatus.Urgent, Name: 'Urgent' },
];

export const formatAlertStatus = (value: CustomerCollectionAlertStatus) =>
  alertStatusOptions.find(x => x.ID === value)?.Name ?? 'Not specified';
